import { Alert, AlertProps } from '@mui/material';

interface ReportingAllMediaTypeTabAlertProps extends AlertProps {}

const ReportingAllMediaTypeTabAlert = (props: ReportingAllMediaTypeTabAlertProps) => {
    return (
        <Alert severity="warning" {...props}>
            Looks like we were not able to find any reporting data with those filters. Please try tweaking your
            selections and we will take another look!
        </Alert>
    );
};

export type { ReportingAllMediaTypeTabAlertProps };
export default ReportingAllMediaTypeTabAlert;
